module.exports = __webpack_public_path__ + "static/media/Jinsilhanja Translated by J_Lee_77777.96d2780c.md";